import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import { invariant } from '@e-socna/utils';
import { getFragmentData, graphql } from '@e-socna/data-layer';
import type { FragmentType, Id } from '@e-socna/data-layer';

import { NoData } from '../Illustrations/NoData';

import { AddressCard } from './Card';
import { NewAddressCard } from './NewCard';

export const AddressesCmp_Address_Fragment = graphql(`
  fragment AddressesCmp_Address_Fragment on Address {
    _id
    ...AddressCardCmp_Address_Fragment
    ...AddressForm_Address_Fragment
  }
`);

interface Props {
  readonly actionsEnabled?: boolean;
  readonly addresses?:
    readonly FragmentType<typeof AddressesCmp_Address_Fragment>[] | null;
  readonly onStartCreate?: () => void;
  readonly onStartRemove?: (id: Id) => void;
  readonly onStartUpdate?: (id: Id) => void;
}

export const Addresses = ({
  actionsEnabled = false,
  addresses: pAddresses,
  onStartCreate: handleStartCreate,
  onStartRemove: handleStartRemove,
  onStartUpdate: handleStartUpdate,
}: Readonly<Props>) => {
  invariant(
    !actionsEnabled ||
      !!(handleStartCreate && handleStartRemove && handleStartUpdate),
    'onStartCreate & onStartRemove & onStartUpdate are required when actionsEnabled is true',
  );

  const addresses = getFragmentData(AddressesCmp_Address_Fragment, pAddresses);

  if (!actionsEnabled && !addresses?.length) {
    return <NoData />;
  }

  return (
    <Box sx={{ pt: 4, width: '100%' }}>
      <Grid container spacing={2}>
        {!addresses?.length ? (
          <NoData />
        ) : (
          addresses.map((address) => (
            <AddressCard
              actionsEnabled={actionsEnabled}
              address={address}
              key={address._id}
              onStartRemove={handleStartRemove}
              onStartUpdate={handleStartUpdate}
            />
          ))
        )}
        {!!(actionsEnabled && handleStartCreate) && (
          <NewAddressCard onStartCreate={handleStartCreate} />
        )}
      </Grid>
    </Box>
  );
};
